import { render, staticRenderFns } from "./Pagedetails.vue?vue&type=template&id=b28228fa&scoped=true&"
import script from "./Pagedetails.vue?vue&type=script&lang=js&"
export * from "./Pagedetails.vue?vue&type=script&lang=js&"
import style0 from "./Pagedetails.vue?vue&type=style&index=0&id=b28228fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28228fa",
  null
  
)

export default component.exports